<template>
  <div ref="scrollContainer" id="page-panel" class="box grow scrollable only-y" >
    <resize-observer @notify="__resizeHanlder" />
    <div class="customer-top-nav no-print">
      <div class="title">
        <span>{{$t("left-menu.settings")}}</span>
      </div>
    </div>
    <h4>{{$t('settings.sections.inventoriesAndProducts')}}</h4>
    <el-row :gutter="20">
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <settingTile  :disabled="!$can('manage','Inventories')" :title="inventorySettingTitle" :description="inventorySettingDescription" section="inventories" icon="mdi mdi-book-open-page-variant"></settingTile>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <settingTile  :disabled="false" :title="productSettingTitle" :description="productSettingDescription" section="items" icon="mdi mdi-barcode"></settingTile>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <settingTile  :disabled="!$can('manage','CMS')" :title="cmsSettingTitle" :description="cmsSettingDescription" section="CMS/settings" icon="el-icon-s-tools"></settingTile>
      </el-col>
    </el-row>
    <h4>{{$t('settings.sections.platformSettings')}}</h4>
    <el-row :gutter="20">
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <settingTile  :title="enterpriseProfileSettingTitle" :description="enterpriseProfileSettingDescription" section="business" icon="el-icon-office-building"></settingTile>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <settingTile  :disabled="false" :title="userSettingTitle" :description="userSettingDescription" section="users" icon="el-icon-user"></settingTile>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <settingTile  :disabled="true || isInvoicingModuleactive !== true" :title="paymentOnBoardingTitle" :description="paymentOnBoardingDescription" section="payment" icon="el-icon-bank-card"></settingTile>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <settingTile  :disabled="false" :title="tagsTitle" :description="tagsDescription" section="tags" icon="el-icon-price-tag"></settingTile>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <settingTile  :disabled="true" :title="panoramaTitle" :description="panoramaDescription" section="tags" imageStyle="width:60px;padding-left:5px;padding-right:5px;float:left;mb-10;" imageUri="/logo-panorama.png"></settingTile>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <settingTile  :disabled="false" :title="datagrapesTitle" :description="datagrapesDescription" section="datagrapes" imageUri="/logo-datagrapes.png"></settingTile>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <settingTile  :disabled="true" :title="quickbooksTitle" :description="quickbooksDescription" section="datagrapes" imageUri="/logo-qb.svg"></settingTile>
      </el-col>
    </el-row>
    <h4>{{$t('settings.sections.communication')}}</h4>
    <el-row :gutter="20">
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <settingTile  :disabled="false" :title="customEmailTitle" :description="customEmailDescription" section="email-custom-content" icon="el-icon-message"></settingTile>
      </el-col>
    </el-row>
    <h4>{{$t('settings.sections.customer')}}</h4>
    <el-row :gutter="20">
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <settingTile  :disabled="true" :title="defaultSettingsTitle" :description="defaultSettingsDescription" section="default-settings" icon="el-icon-setting"></settingTile>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <settingTile  :disabled="true" :title="settingToolTitle" :description="settingToolDescription" section="setting-tool" icon="el-icon-s-tools"></settingTile>
      </el-col>
    </el-row>
    <h4>{{$t('settings.sections.CMS')}}</h4>
    <el-row :gutter="20">
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <settingTile  :disabled="!$can('manage','CMS')" :title="cmsGallerySettingTitle" :description="cmsGallerySettingDescription" section="CMS/galleries" icon="el-icon-picture"></settingTile>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <settingTile  :disabled="!$can('manage','CMS')" :title="cmsProductTitle" :description="cmsProductDescription" section="CMS/products" icon="el-icon-s-goods"></settingTile>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <settingTile  :disabled="!$can('manage','CMS')" :title="cmsProviderTitle" :description="cmsProviderDescription" section="CMS/providers" icon="el-icon-office-building"></settingTile>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <settingTile  :disabled="!$can('manage','CMS')" :title="cmsBlogTitle" :description="cmsBlogDescription" section="CMS/blogs" icon="el-icon-document-copy"></settingTile>
      </el-col>
    </el-row>
    <h4>{{$t('settings.sections.carousel')}}</h4>
    <el-row :gutter="20">
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <settingTile  :disabled="!$can('manage','CMS')" :title="cmsCarouselTitle" :description="cmsCarouselDescription" section="CMS/carousels" icon="el-icon-picture"></settingTile>
      </el-col>
    </el-row>
  </div>
</template>
<script>
//import Section
import settingTile from './components/setting-tile.vue'
import {  mapGetters } from 'vuex';
import axios from 'axios'
// import quickbooks from '/logo-quickbooks.svg';

export default {
  name : "reports",
  data() {
    return {
      reports : [],
      loading:false,
    };
  },
  components : {
    settingTile
  },
  computed : {
    reportByCategory(){
      let reports = [];
      let category = null;
      _.forEach(this.reports, r=>{

        if(this.$can('read', r.resource)){
          if(category==null || (category!=null && category.type!=r.type)){
            if(category!=null)reports.push(category);
            category = {type:r.type, reports:[]}
          }
          category.reports.push(r);
        }


      })
      reports.push(category);
      return reports;
    },
    cmsSettingTitle () {
      return this.$i18n.t('settings.cmsSettings.title');
    },
    cmsSettingDescription () {
      return this.$i18n.t('settings.cmsSettings.description');
    },
    cmsGallerySettingTitle () {
      return this.$i18n.t('settings.cmsGallery.title');
    },
    cmsGallerySettingDescription () {
      return this.$i18n.t('settings.cmsGallery.description');
    },
    cmsProductTitle () {
      return this.$i18n.t('settings.cmsProduct.title');
    },
    cmsProductDescription () {
      return this.$i18n.t('settings.cmsProduct.description');
    },
    cmsProviderTitle () {
      return this.$i18n.t('settings.cmsProvider.title');
    },
    cmsProviderDescription () {
      return this.$i18n.t('settings.cmsProvider.description');
    },
    cmsBlogTitle () {
      return this.$i18n.t('settings.cmsBlog.title');
    },
    cmsBlogDescription () {
      return this.$i18n.t('settings.cmsBlog.description');
    },
    cmsCarouselTitle () {
      return this.$i18n.t('settings.cmsCarousel.title');
    },
    cmsCarouselDescription () {
      return this.$i18n.t('settings.cmsCarousel.description');
    },
    inventorySettingTitle () {
      return this.$i18n.t('settings.inventory.title');
    },
    inventorySettingDescription () {
      return this.$i18n.t('settings.inventory.description');
    },
    productSettingTitle () {
      return this.$i18n.t('settings.product.title');
    },
    productSettingDescription () {
      return this.$i18n.t('settings.product.description');
    },
    userSettingTitle () {
      return this.$i18n.t('settings.user.title');
    },
    userSettingDescription () {
      return this.$i18n.t('settings.user.description');
    },
    enterpriseProfileSettingTitle () {
      return this.$i18n.t('settings.profile.title');
    },
    enterpriseProfileSettingDescription () {
      return this.$i18n.t('settings.profile.description');
    },
    paymentOnBoardingTitle () {
      return this.$i18n.t('settings.paymentOnBoarding.title');
    },
    paymentOnBoardingDescription () {
      return this.$i18n.t('settings.paymentOnBoarding.description');
    },
    tagsTitle () {
      return this.$i18n.t('settings.tags.title');
    },
    tagsDescription () {
      return this.$i18n.t('settings.tags.description');
    },
    panoramaTitle () {
      return this.$i18n.t('settings.panorama.title');
    },
    panoramaDescription () {
      return this.$i18n.t('settings.panorama.description');
    },
    datagrapesTitle () {
      return this.$i18n.t('settings.datagrapes.title');
    },
    datagrapesDescription () {
      return this.$i18n.t('settings.datagrapes.description');
    },
   quickbooksTitle () {
      return this.$i18n.t('settings.qb.title');
    },
    quickbooksDescription () {
      return this.$i18n.t('settings.qb.description');
    },
    customEmailTitle () {
      return this.$i18n.t('settings.customEmail.title');
    },
    customEmailDescription () {
      return this.$i18n.t('settings.customEmail.description');
    },
    defaultSettingsTitle () {
      return this.$i18n.t('settings.defaultSettings.title');
    },
    defaultSettingsDescription () {
      return this.$i18n.t('settings.defaultSettings.description');
    },
    settingToolTitle () {
      return this.$i18n.t('settings.settingTool.title');
    },
    settingToolDescription () {
      return this.$i18n.t('settings.settingTool.description');
    },
    ...mapGetters(['isInvoicingModuleactive'])
  },
  methods : {
		setPageWidth() {
			this.pageWidth = document.getElementById('page-panel').offsetWidth;
			this.pageHeight = document.getElementById('page-panel').offsetHeight;
		},
    __resizeHanlder: _.throttle(function (e) {
  			this.setPageWidth();
  		}, 700),
  },
  created(){

  }
}
</script>
<style lang="scss" scoped>


.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:80px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}


</style>
